import { getEnhancedPackagesConfig } from '@/configs/enhancedPackages';
import { useChurch } from '@/hooks/church/useChurch';
import { useGlobalSettings } from '@/hooks/useGlobalSettings';

export const useEnhancedPackagesConfig = () => {
  const { currentChurch } = useGlobalSettings();
  const { data: church } = useChurch(currentChurch?.churchId);

  return getEnhancedPackagesConfig({ isEnhanced: church?.isEnhanced });
};
